export default {
  todo: {
    defaultRes: require('../img/pages/todo.jpg'),
    hiRes: require('../img/pages/todo@2x.jpg')
  },
  'homepage-hero': {
    defaultRes: require('../img/pages/homepage/homepage-hero.png')
  },
  'rainer-blair': {
    defaultRes: require('../img/pages/from-our-ceo/rainer-blair.jpg'),
    hiRes: require('../img/pages/from-our-ceo/rainer-blair.jpg')
  },
  signature: {
    defaultRes: require('../img/pages/from-our-ceo/signature.jpg'),
    hiRes: require('../img/pages/from-our-ceo/signature@2x.jpg')
  },
  //sdgs
  'sdg-3': {
    defaultRes: require('../img/sdg/sdg-3.jpg'),
    hiRes: require('../img/sdg/sdg-3@2x.jpg')
  },
  'sdg-5': {
    defaultRes: require('../img/sdg/sdg-5.jpg'),
    hiRes: require('../img/sdg/sdg-5@2x.jpg')
  },
  'sdg-6': {
    defaultRes: require('../img/sdg/sdg-6.jpg'),
    hiRes: require('../img/sdg/sdg-6@2x.jpg')
  },
  'sdg-8': {
    defaultRes: require('../img/sdg/sdg-8.png'),
    hiRes: require('../img/sdg/sdg-8@2x.png')
  },
  'sdg-9': {
    defaultRes: require('../img/sdg/sdg-9.png'),
    hiRes: require('../img/sdg/sdg-9@2x.png')
  },
  'sdg-12': {
    defaultRes: require('../img/sdg/sdg-12.jpg'),
    hiRes: require('../img/sdg/sdg-12@2x.jpg')
  },
  'sdg-13': {
    defaultRes: require('../img/sdg/sdg-13.jpg'),
    hiRes: require('../img/sdg/sdg-13@2x.jpg')
  },
  'sdg-14': {
    defaultRes: require('../img/sdg/sdg-14.png'),
    hiRes: require('../img/sdg/sdg-14.png')
  },
  // company overview images
  diagnostics: {
    defaultRes: require('../img/pages/overview/diagnostics.png'),
    hiRes: require('../img/pages/overview/diagnostics.png')
  },
  'eas-logos': {
    defaultRes: require('../img/pages/overview/eas-logos.png'),
    hiRes: require('../img/pages/overview/eas-logos.png')
  },
  'environmental-applied-solutions': {
    defaultRes: require('../img/pages/overview/environmental-applied-solutions.png'),
    hiRes: require('../img/pages/overview/environmental-applied-solutions.png')
  },
  'environment-overlay-cytvia-uppsala': {
    defaultRes: require('../img/pages/environment/overlay/cytvia-uppsala.jpg'),
    hiRes: require('../img/pages/environment/overlay/cytvia-uppsala@2x.jpg')
  },
  'environment-overlay-future-fashion': {
    defaultRes: require('../img/pages/environment/overlay/future-fashion.jpg'),
    hiRes: require('../img/pages/environment/overlay/future-fashion@2x.jpg')
  },
  'environment-overlay-goals': {
    defaultRes: require('../img/pages/environment/overlay/goals.png'),
    hiRes: require('../img/pages/environment/overlay/goals.png')
  },
  'environment-overlay-iceberg': {
    defaultRes: require('../img/pages/environment/overlay/iceberg.jpg'),
    hiRes: require('../img/pages/environment/overlay/iceberg@2x.jpg')
  },
  'environment-overlay-merganser-female': {
    defaultRes: require('../img/pages/environment/overlay/environment-hero.jpg'),
    hiRes: require('../img/pages/environment/overlay/environment-hero.jpg')
  },
  'environment-overlay-ocean-pier': {
    defaultRes: require('../img/pages/environment/overlay/ocean-pier.jpg'),
    hiRes: require('../img/pages/environment/overlay/ocean-pier@2x.jpg')
  },
  'environment-overlay-open-range': {
    defaultRes: require('../img/pages/environment/overlay/open-range.jpg'),
    hiRes: require('../img/pages/environment/overlay/open-range@2x.jpg')
  },
  'environment-overlay-rainy-day': {
    defaultRes: require('../img/pages/environment/overlay/rainy-day.jpg'),
    hiRes: require('../img/pages/environment/overlay/rainy-day@2x.jpg')
  },
  'environment-overlay-whale-fin': {
    defaultRes: require('../img/pages/environment/overlay/whale-fin.jpg'),
    hiRes: require('../img/pages/environment/overlay/whale-fin@2x.jpg')
  },
  'life-sciences': {
    defaultRes: require('../img/pages/overview/life-sciences.png'),
    hiRes: require('../img/pages/overview/life-sciences.png')
  },
  // company overview overlay images
  'overview-hero': {
    defaultRes: require('../img/pages/overview/hero.jpg'),
    hiRes: require('../img/pages/overview/hero@2x.jpg')
  },
  'overview-world-map': {
    defaultRes: require('../img/pages/overview/world-map.png'),
    hiRes: require('../img/pages/overview/world-map.png')
  },
  'overview-overlay-cover': {
    defaultRes: require('../img/pages/overview/overlay/cover.jpg'),
    hiRes: require('../img/pages/overview/overlay/cover@2x.jpg')
  },
  'overview-overlay-story': {
    defaultRes: require('../img/pages/overview/overlay/story.jpg'),
    hiRes: require('../img/pages/overview/overlay/story@2x.jpg')
  },
  'overview-overlay-dbs': {
    defaultRes: require('../img/pages/overview/overlay/dbs.jpg'),
    hiRes: require('../img/pages/overview/overlay/dbs@2x.jpg')
  },
  'overview-overlay-pillars': {
    defaultRes: require('../img/pages/overview/overlay/pillars.png'),
    hiRes: require('../img/pages/overview/overlay/pillars@2x.png')
  },
  'overview-overlay-business-system': {
    defaultRes: require('../img/pages/overview/overlay/danaher-business-system.png'),
    hiRes: require('../img/pages/overview/overlay/danaher-business-system@2x.png')
  },
  'overview-overlay-dental': {
    defaultRes: require('../img/pages/overview/overlay/dental.jpg'),
    hiRes: require('../img/pages/overview/overlay/dental@2x.jpg')
  },
  'overview-overlay-diagnostics': {
    defaultRes: require('../img/pages/overview/overlay/diagnostics.jpg'),
    hiRes: require('../img/pages/overview/overlay/diagnostics.jpg')
  },
  'overview-overlay-diagnostics-data': {
    defaultRes: require('../img/pages/overview/overlay/dana-diagnostics-info.png'),
    hiRes: require('../img/pages/overview/overlay/dana-diagnostics-info.png')
  },
  'overview-overlay-diagnostics-doctor': {
    defaultRes: require('../img/pages/overview/overlay/diagnostics-doctor.png'),
    hiRes: require('../img/pages/overview/overlay/diagnostics-doctor.png')
  },
  'overview-overlay-diagnostics-revenue': {
    defaultRes: require('../img/pages/overview/overlay/diagnostics-revenue.png'),
    hiRes: require('../img/pages/overview/overlay/diagnostics-revenue@2x.png')
  },
  'overview-overlay-diagnostics-companies': {
    defaultRes: require('../img/pages/overview/overlay/diagnostics-companies.png'),
    hiRes: require('../img/pages/overview/overlay/diagnostics-companies@2x.png')
  },
  'overview-overlay-environmental-data': {
    defaultRes: require('../img/pages/overview/overlay/dana-environmental-info.png'),
    hiRes: require('../img/pages/overview/overlay/dana-environmental-info.png')
  },
  'overview-overlay-life-sciences': {
    defaultRes: require('../img/pages/overview/overlay/life-sciences.jpg'),
    hiRes: require('../img/pages/overview/overlay/life-sciences.jpg')
  },
  'overview-overlay-life-sciences-data': {
    defaultRes: require('../img/pages/overview/overlay/dana-lifesciences-info.png'),
    hiRes: require('../img/pages/overview/overlay/dana-lifesciences-info.png')
  },
  'overview-overlay-life-sciences-lab': {
    defaultRes: require('../img/pages/overview/overlay/life-sciences-lab.jpg'),
    hiRes: require('../img/pages/overview/overlay/life-sciences-lab@2x.jpg')
  },
  'overview-overlay-life-sciences-revenue': {
    defaultRes: require('../img/pages/overview/overlay/life-sciences-revenue.png'),
    hiRes: require('../img/pages/overview/overlay/life-sciences-revenue@2x.png')
  },
  'overview-overlay-life-sciences-companies': {
    defaultRes: require('../img/pages/overview/overlay/life-sciences-companies.png'),
    hiRes: require('../img/pages/overview/overlay/life-sciences-companies@2x.png')
  },
  'overview-overlay-dental-revenue': {
    defaultRes: require('../img/pages/overview/overlay/dental-revenue.png'),
    hiRes: require('../img/pages/overview/overlay/dental-revenue@2x.png')
  },
  'overview-overlay-dental-companies': {
    defaultRes: require('../img/pages/overview/overlay/dental-companies.png'),
    hiRes: require('../img/pages/overview/overlay/dental-companies@2x.png')
  },
  'overview-overlay-product-identification': {
    defaultRes: require('../img/pages/overview/overlay/product-identification.jpg'),
    hiRes: require('../img/pages/overview/overlay/product-identification@2x.jpg')
  },
  'overview-overlay-water-quality': {
    defaultRes: require('../img/pages/overview/overlay/water-quality.jpg'),
    hiRes: require('../img/pages/overview/overlay/water-quality@2x.jpg')
  },
  'overview-overlay-water-quality-drinking': {
    defaultRes: require('../img/pages/overview/overlay/water-quality-drinking.jpg'),
    hiRes: require('../img/pages/overview/overlay/water-quality-drinking@2x.jpg')
  },
  'overview-overlay-environmental-revenue': {
    defaultRes: require('../img/pages/overview/overlay/environmental-revenue.png'),
    hiRes: require('../img/pages/overview/overlay/environmental-revenue@2x.png')
  },
  'overview-overlay-water-quality-companies': {
    defaultRes: require('../img/pages/overview/overlay/water-quality-companies.png'),
    hiRes: require('../img/pages/overview/overlay/water-quality-companies@2x.png')
  },
  'overview-overlay-product-id-companies': {
    defaultRes: require('../img/pages/overview/overlay/product-id-companies.png'),
    hiRes: require('../img/pages/overview/overlay/product-id-companies@2x.png')
  },
  'overview-overlay-product-id-shop': {
    defaultRes: require('../img/pages/overview/overlay/product-id-shop.jpg'),
    hiRes: require('../img/pages/overview/overlay/product-id-shop@2x.jpg')
  },
  // innovation overlay images
  'innovation-overlay-cover': {
    defaultRes: require('../img/pages/innovation/overlay/cover.jpg'),
    hiRes: require('../img/pages/innovation/overlay/cover.jpg')
  },
  'innovation-overlay-innovation-defines-future': {
    defaultRes: require('../img/pages/innovation/overlay/innovation-defines-future.jpg'),
    hiRes: require('../img/pages/innovation/overlay/innovation-defines-future.jpg')
  },
  'innovation-overlay-gene-therapy': {
    defaultRes: require('../img/pages/innovation/overlay/gene-therapy.jpg'),
    hiRes: require('../img/pages/innovation/overlay/gene-therapy.jpg')
  },
  'innovation-overlay-friendly-competition': {
    defaultRes: require('../img/pages/innovation/overlay/friendly-competition.jpg'),
    hiRes: require('../img/pages/innovation/overlay/friendly-competition.jpg')
  },
  'innovation-overlay-mars': {
    defaultRes: require('../img/pages/innovation/overlay/mars.jpg'),
    hiRes: require('../img/pages/innovation/overlay/mars.jpg')
  },
  'innovation-overlay-protecting-intellectual': {
    defaultRes: require('../img/pages/innovation/overlay/protecting-intellectual.jpg'),
    hiRes: require('../img/pages/innovation/overlay/protecting-intellectual.jpg')
  },
  'innovation-overlay-cytvia-equipment': {
    defaultRes: require('../img/pages/innovation/overlay/cytvia-equipment.jpg'),
    hiRes: require('../img/pages/innovation/overlay/cytvia-equipment.jpg')
  },
  'innovation-overlay-cepheid': {
    defaultRes: require('../img/pages/innovation/overlay/cepheid.jpg'),
    hiRes: require('../img/pages/innovation/overlay/cepheid.jpg')
  },
  'innovation-overlay-corporate-audit-program': {
    defaultRes: require('../img/pages/innovation/overlay/corporate-audit-program.jpg'),
    hiRes: require('../img/pages/innovation/overlay/corporate-audit-program.jpg')
  },
  'innovation-overlay-medical': {
    defaultRes: require('../img/pages/innovation/overlay/medical.jpg'),
    hiRes: require('../img/pages/innovation/overlay/medical.jpg')
  },
  // 'innovation-overlay-better-outcomes-graph': {
  //   defaultRes: require('../img/pages/innovation/overlay/better-outcomes-graph.jpg'),
  //   hiRes: require('../img/pages/innovation/overlay/better-outcomes-graph@2x.jpg')
  // },
  // 'innovation-overlay-smiles': {
  //   defaultRes: require('../img/pages/innovation/overlay/smiles.jpg'),
  //   hiRes: require('../img/pages/innovation/overlay/smiles@2x.jpg')
  // },
  // 'innovation-overlay-recycling-wastewater': {
  //   defaultRes: require('../img/pages/innovation/overlay/recycling-wastewater.jpg'),
  //   hiRes: require('../img/pages/innovation/overlay/recycling-wastewater@2x.jpg')
  // },
  // 'innovation-overlay-astronauts': {
  //   defaultRes: require('../img/pages/innovation/overlay/astronauts.jpg'),
  //   hiRes: require('../img/pages/innovation/overlay/astronauts@2x.jpg')
  // },
  // people overlay images
  'people-overlay-baseline-metrics-1': {
    defaultRes: require('../img/pages/people/overlay/baseline-metrics-1.png'),
    hiRes: require('../img/pages/people/overlay/baseline-metrics-1.png')
  },
  'people-overlay-baseline-metrics-2': {
    defaultRes: require('../img/pages/people/overlay/baseline-metrics-2.png'),
    hiRes: require('../img/pages/people/overlay/baseline-metrics-2.png')
  },
  'people-overlay-cover': {
    defaultRes: require('../img/pages/people/overlay/cover.jpg'),
    hiRes: require('../img/pages/people/overlay/cover@2x.jpg')
  },
  'people-overlay-goals': {
    defaultRes: require('../img/pages/people/overlay/goals.png'),
    hiRes: require('../img/pages/people/overlay/goals.png')
  },
  'people-overlay-personal-potential': {
    defaultRes: require('../img/pages/people/overlay/personal-potential.jpg'),
    hiRes: require('../img/pages/people/overlay/personal-potential.jpg')
  },
  'people-overlay-spotlight': {
    defaultRes: require('../img/pages/people/overlay/spotlight.jpg'),
    hiRes: require('../img/pages/people/overlay/spotlight.jpg')
  },
  'people-overlay-cepheid': {
    defaultRes: require('../img/pages/people/overlay/cepheid.jpg'),
    hiRes: require('../img/pages/people/overlay/cepheid@2x.jpg')
  },
  'people-overlay-esko': {
    defaultRes: require('../img/pages/people/overlay/esko.jpg'),
    hiRes: require('../img/pages/people/overlay/esko@2x.jpg')
  },
  'people-overlay-volunteer-time-off-1': {
    defaultRes: require('../img/pages/people/overlay/volunteer-time-off-1.jpg'),
    hiRes: require('../img/pages/people/overlay/volunteer-time-off-1.jpg')
  },
  'people-overlay-volunteer-time-off-2': {
    defaultRes: require('../img/pages/people/overlay/volunteer-time-off-2.jpg'),
    hiRes: require('../img/pages/people/overlay/volunteer-time-off-2.jpg')
  },
  'people-overlay-commitment-human-rights': {
    defaultRes: require('../img/pages/people/overlay/commitment-human-rights.jpg'),
    hiRes: require('../img/pages/people/overlay/commitment-human-rights.jpg')
  },
  'people-overlay-lgbt-equality': {
    defaultRes: require('../img/pages/people/overlay/lgbt-equality.jpg'),
    hiRes: require('../img/pages/people/overlay/lgbt-equality.jpg')
  },
  'people-overlay-lgbt-equality-icons': {
    defaultRes: require('../img/pages/people/overlay/lgbt-equality-icons.png'),
    hiRes: require('../img/pages/people/overlay/lgbt-equality-icons.png')
  },
  'people-overlay-diversity-inclusion': {
    defaultRes: require('../img/pages/people/overlay/diversity-inclusion.jpg'),
    hiRes: require('../img/pages/people/overlay/diversity-inclusion.jpg')
  },
  'people-overlay-supporting-black-associates': {
    defaultRes: require('../img/pages/people/overlay/supporting-black-associates.jpg'),
    hiRes: require('../img/pages/people/overlay/supporting-black-associates.jpg')
  },
  'people-overlay-supporting-black-associates-logos': {
    defaultRes: require('../img/pages/people/overlay/dana-diversity-logos.png'),
    hiRes: require('../img/pages/people/overlay/dana-diversity-logos.png')
  },
  'people-overlay-diversity-metrics': {
    defaultRes: require('../img/pages/people/overlay/diversity-metrics.jpg'),
    hiRes: require('../img/pages/people/overlay/diversity-metrics.jpg')
  },
  'people-overlay-opco-spotlight': {
    defaultRes: require('../img/pages/people/overlay/opco-spotlight.jpg'),
    hiRes: require('../img/pages/people/overlay/opco-spotlight.jpg')
  },
  'people-overlay-opco-spotlight-cropped': {
    defaultRes: require('../img/pages/people/overlay/opco-spotlight-cropped.jpeg'),
    hiRes: require('../img/pages/people/overlay/opco-spotlight-cropped.jpeg')
  },
  'people-overlay-args': {
    defaultRes: require('../img/pages/people/overlay/args.jpg'),
    hiRes: require('../img/pages/people/overlay/args.jpg')
  },
  'people-overlay-diversity-around-the-world': {
    defaultRes: require('../img/pages/people/overlay/diversity-around-the-world.jpg'),
    hiRes: require('../img/pages/people/overlay/diversity-around-the-world.jpg')
  },
  'people-overlay-spotlight-2': {
    defaultRes: require('../img/pages/people/overlay/spotlight-2.jpg'),
    hiRes: require('../img/pages/people/overlay/spotlight-2.jpg')
  },
  'people-overlay-our-communities': {
    defaultRes: require('../img/pages/people/overlay/our-communities.jpg'),
    hiRes: require('../img/pages/people/overlay/our-communities.jpg')
  },
  'people-overlay-kids-go-virtual-china': {
    defaultRes: require('../img/pages/people/overlay/kids-go-virtual-china.jpg'),
    hiRes: require('../img/pages/people/overlay/kids-go-virtual-china.jpg')
  },
  'people-overlay-showing-heart': {
    defaultRes: require('../img/pages/people/overlay/showing-heart.jpg'),
    hiRes: require('../img/pages/people/overlay/showing-heart.jpg')
  },
  'people-overlay-professional-potential': {
    defaultRes: require('../img/pages/people/overlay/professional-potential.jpg'),
    hiRes: require('../img/pages/people/overlay/professional-potential.jpg')
  },
  'people-overlay-learning-management-system': {
    defaultRes: require('../img/pages/people/overlay/learning-management-system.jpg'),
    hiRes: require('../img/pages/people/overlay/learning-management-system.jpg')
  },
  'people-overlay-di-logos': {
    defaultRes: require('../img/pages/people/overlay/di-logos.png'),
    hiRes: require('../img/pages/people/overlay/di-logos@2x.png')
  },
  'people-overlay-north-asia': {
    defaultRes: require('../img/pages/people/overlay/north-asia.jpg'),
    hiRes: require('../img/pages/people/overlay/north-asia@2x.jpg')
  },
  'people-overlay-shantel': {
    defaultRes: require('../img/pages/people/overlay/shantel.jpg'),
    hiRes: require('../img/pages/people/overlay/shantel@2x.jpg')
  },
  'people-overlay-arg-women': {
    defaultRes: require('../img/pages/people/overlay/arg-women.jpg'),
    hiRes: require('../img/pages/people/overlay/arg-women@2x.jpg')
  },
  'people-overlay-arg-latinx': {
    defaultRes: require('../img/pages/people/overlay/arg-latinx.jpg'),
    hiRes: require('../img/pages/people/overlay/arg-latinx@2x.jpg')
  },
  'people-overlay-arg-black-leadership': {
    defaultRes: require('../img/pages/people/overlay/arg-black-leadership.jpg'),
    hiRes: require('../img/pages/people/overlay/arg-black-leadership@2x.jpg')
  },
  'people-overlay-equality': {
    defaultRes: require('../img/pages/people/overlay/equality.jpg'),
    hiRes: require('../img/pages/people/overlay/equality@2x.jpg')
  },
  'people-overlay-pall': {
    defaultRes: require('../img/pages/people/overlay/pall.jpg'),
    hiRes: require('../img/pages/people/overlay/pall@2x.jpg')
  },
  'people-overlay-sanitation': {
    defaultRes: require('../img/pages/people/overlay/sanitation.jpg'),
    hiRes: require('../img/pages/people/overlay/sanitation@2x.jpg')
  },
  'people-overlay-adream': {
    defaultRes: require('../img/pages/people/overlay/adream.jpg'),
    hiRes: require('../img/pages/people/overlay/adream@2x.jpg')
  },
  'people-overlay-partners': {
    defaultRes: require('../img/pages/people/overlay/dana-corporate-logos.png'),
    hiRes: require('../img/pages/people/overlay/dana-corporate-logos.png')
  },
  'people-overlay-4e-toolkit': {
    defaultRes: require('../img/pages/people/overlay/4e-toolkit.png'),
    hiRes: require('../img/pages/people/overlay/4e-toolkit.png')
  },
  'people-overlay-mexico-city': {
    defaultRes: require('../img/pages/people/overlay/mexico-city.jpg'),
    hiRes: require('../img/pages/people/overlay/mexico-city@2x.jpg')
  },
  'people-overlay-loveland': {
    defaultRes: require('../img/pages/people/overlay/loveland.jpg'),
    hiRes: require('../img/pages/people/overlay/loveland@2x.jpg')
  },
  'people-overlay-shanghai': {
    defaultRes: require('../img/pages/people/overlay/shanghai.jpg'),
    hiRes: require('../img/pages/people/overlay/shanghai@2x.jpg')
  },
  'people-overlay-stat-1': {
    defaultRes: require('../img/pages/people/overlay/stat-1.png'),
    hiRes: require('../img/pages/people/overlay/stat-1.png')
  },
  'people-overlay-stat-2': {
    defaultRes: require('../img/pages/people/overlay/stat-2.png'),
    hiRes: require('../img/pages/people/overlay/stat-2.png')
  },
  'people-overlay-stat-3': {
    defaultRes: require('../img/pages/people/overlay/stat-3.png'),
    hiRes: require('../img/pages/people/overlay/stat-3.png')
  },
  'people-overlay-stat-4-5': {
    defaultRes: require('../img/pages/people/overlay/stat-4-5.png'),
    hiRes: require('../img/pages/people/overlay/stat-4-5.png')
  },
  'people-overlay-dc': {
    defaultRes: require('../img/pages/people/overlay/dc.jpg'),
    hiRes: require('../img/pages/people/overlay/dc@2x.jpg')
  },
  'people-overlay-scholarship-program': {
    defaultRes: require('../img/pages/people/overlay/scholarship-program.jpg'),
    hiRes: require('../img/pages/people/overlay/scholarship-program@2x.jpg')
  },
  'people-overlay-initiatives': {
    defaultRes: require('../img/pages/people/overlay/initiatives.jpg'),
    hiRes: require('../img/pages/people/overlay/initiatives@2x.jpg')
  },
  // environment overlay images
  'environment-overlay-cover': {
    defaultRes: require('../img/pages/environment/overlay/cover.jpg'),
    hiRes: require('../img/pages/environment/overlay/cover@2x.jpg')
  },
  'environment-overlay-algae-bloom': {
    defaultRes: require('../img/pages/environment/overlay/algae-bloom.jpg'),
    hiRes: require('../img/pages/environment/overlay/algae-bloom@2x.jpg')
  },
  'environment-overlay-beckman-coulter': {
    defaultRes: require('../img/pages/environment/overlay/beckman-coulter.jpg'),
    hiRes: require('../img/pages/environment/overlay/beckman-coulter@2x.jpg')
  },
  'environment-overlay-initiatives': {
    defaultRes: require('../img/pages/environment/overlay/initiatives.jpg'),
    hiRes: require('../img/pages/environment/overlay/initiatives@2x.jpg')
  },
  'environment-overlay-hach': {
    defaultRes: require('../img/pages/environment/overlay/hach.jpg'),
    hiRes: require('../img/pages/environment/overlay/hach@2x.jpg')
  },
  'environment-overlay-coloring-coral': {
    defaultRes: require('../img/pages/environment/overlay/coloring-coral.jpg'),
    hiRes: require('../img/pages/environment/overlay/coloring-coral@2x.jpg')
  },
  // foundational-elements image
  'foundational-elements-overview': {
    defaultRes: require('../img/pages/foundational-elements/overview.jpg'),
    hiRes: require('../img/pages/foundational-elements/overview.jpg')
  },
  'foundational-elements-ir-magazine': {
    defaultRes: require('../img/pages/foundational-elements/ir-magazine.png'),
    hiRes: require('../img/pages/foundational-elements/ir-magazine@2x.png')
  },
  // foundational-elements overlay images
  'foundational-elements-overlay-coc-stat': {
    defaultRes: require('../img/pages/foundational-elements/overlay/coc-stat.png'),
    hiRes: require('../img/pages/foundational-elements/overlay/coc-stat.png')
  },
  'foundational-elements-overlay-cover': {
    defaultRes: require('../img/pages/foundational-elements/overlay/cover.jpg'),
    hiRes: require('../img/pages/foundational-elements/overlay/cover@2x.jpg')
  },
  'foundational-elements-overlay-speak-up': {
    defaultRes: require('../img/pages/foundational-elements/overlay/speak-up.jpg'),
    hiRes: require('../img/pages/foundational-elements/overlay/speak-up@2x.jpg')
  },
  'foundational-elements-overlay-ir-magazine': {
    defaultRes: require('../img/pages/foundational-elements/overlay/ir-magazine.png'),
    hiRes: require('../img/pages/foundational-elements/overlay/ir-magazine@2x.png')
  },
  'foundational-elements-overlay-ethical-business-conduct': {
    defaultRes: require('../img/pages/foundational-elements/overlay/ethical-business-conduct.jpg'),
    hiRes: require('../img/pages/foundational-elements/overlay/ethical-business-conduct.jpg')
  },
  'foundational-elements-overlay-graph-1': {
    defaultRes: require('../img/pages/foundational-elements/overlay/graph-1.png'),
    hiRes: require('../img/pages/foundational-elements/overlay/graph-1.png')
  },
  'foundational-elements-overlay-ceo-succession-planning': {
    defaultRes: require('../img/pages/foundational-elements/overlay/ceo-succession-planning.jpg'),
    hiRes: require('../img/pages/foundational-elements/overlay/ceo-succession-planning.jpg')
  },
  'foundational-elements-overlay-spotlight-climate-change': {
    defaultRes: require('../img/pages/foundational-elements/overlay/spotlight-climate-change.jpg'),
    hiRes: require('../img/pages/foundational-elements/overlay/spotlight-climate-change.jpg')
  },
  'foundational-elements-overlay-policies': {
    defaultRes: require('../img/pages/foundational-elements/overlay/policies.jpg'),
    hiRes: require('../img/pages/foundational-elements/overlay/policies.jpg')
  },
  // COVID-19
  'covid-19-covid-1': {
    defaultRes: require('../img/pages/covid-19/covid-1.jpg'),
    hiRes: require('../img/pages/covid-19/covid-1.jpg')
  },
  'covid-19-covid-2': {
    defaultRes: require('../img/pages/covid-19/covid-2.jpg'),
    hiRes: require('../img/pages/covid-19/covid-2.jpg')
  },
  'covid-19-covid-3': {
    defaultRes: require('../img/pages/covid-19/covid-3.jpg'),
    hiRes: require('../img/pages/covid-19/covid-3.jpg')
  },
  'covid-19-covid-4': {
    defaultRes: require('../img/pages/covid-19/covid-4.jpg'),
    hiRes: require('../img/pages/covid-19/covid-4.jpg')
  },
  'covid-19-covid-5': {
    defaultRes: require('../img/pages/covid-19/covid-5.jpg'),
    hiRes: require('../img/pages/covid-19/covid-5.jpg')
  },
  'covid-19-covid-5-6': {
    defaultRes: require('../img/pages/covid-19/covid-5-6.jpg'),
    hiRes: require('../img/pages/covid-19/covid-5-6.jpg')
  },
  'covid-19-covid-6': {
    defaultRes: require('../img/pages/covid-19/covid-6.jpg'),
    hiRes: require('../img/pages/covid-19/covid-6.jpg')
  },
  'covid-19-covid-7': {
    defaultRes: require('../img/pages/covid-19/covid-7.jpg'),
    hiRes: require('../img/pages/covid-19/covid-7.jpg')
  },
  'covid-19-covid-8': {
    defaultRes: require('../img/pages/covid-19/covid-8.jpg'),
    hiRes: require('../img/pages/covid-19/covid-8.jpg')
  }
}
